import { Navigate, useLocation } from 'react-router-dom';

/**
 * An address that was renamed: sends old links, bookmarks and open windows to the
 * new address with the same query string (for example ?noteId=...).
 */
export default function RenamedRoute({ to }) {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
}
